// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://platzi-store.herokuapp.com',
  firebaseConfig:
  {
    apiKey: 'AIzaSyAhrJS_gzVRTY7Te6GUzMjtrOoUCEB31Sw',
    authDomain: 'test-5eb52.firebaseapp.com',
    projectId: 'test-5eb52',
    storageBucket: 'test-5eb52.appspot.com',
    messagingSenderId: '902720563527',
    appId: '1:902720563527:web:d197db56bd3197d8b88462',
    measurementId: 'G-FN33C7C5GN'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
